import React, { useState } from "react"
import { GET_ITEM_LIMIT, MFI_MODULE } from "constants/constants"
import { IPermission } from "interfaces/dataInterfaces"
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query"
import useCommon from "hooks/useCommon"
import {
  useDeleteSurveyMFIMutation,
  useDownloadOriginSurveyMFIMutation,
  useDownloadSurveyFileMFIMutation,
  useGetSurveyMFIListQuery,
  useGetSurveyMFIQuery,
  useListCommodityByBasketMFIQuery,
} from "../../services/mfi/survey"
import SurveyPage from "./SurveyPage"
import { ISurveyData } from "./SurveyRPME"

const permission: IPermission = {
  moduleId: MFI_MODULE,
  subModule: "surveys",
}

const initialState = {
  admCode: null,
  addAdmCode: null,
  xlsFormId: null,
  query: "",
  pageNumber: 1,
  itemList: GET_ITEM_LIMIT,
  actionItem: null,
}

function SurveyMFI() {
  const { showSnackBar } = useCommon()
  const [data, setData] = useState<ISurveyData>(initialState)
  const { admCode, query, pageNumber, itemList, actionItem } = data

  const { data: surveyData } = useGetSurveyMFIListQuery({
    adm0Code: admCode ?? 0,
    search: query,
    skip: pageNumber === 1 ? 0 : (pageNumber - 1) * itemList,
    top: itemList,
  })
  const { data: surveyById } = useGetSurveyMFIQuery(actionItem?.item?.surveyId ?? 0, {
    skip: !actionItem || actionItem.action !== "details",
  })
  const { data: commodityBasket } = useListCommodityByBasketMFIQuery(
    { surveyId: actionItem?.item?.surveyId ?? 0 },
    { skip: !actionItem || actionItem.action !== "details" },
  )
  const [deleteSurvey] = useDeleteSurveyMFIMutation()
  const [downloadSurveyFile] = useDownloadSurveyFileMFIMutation()
  const [downloadOriginSurvey] = useDownloadOriginSurveyMFIMutation()

  const onDelete = (id: number) => {
    deleteSurvey(id)
  }

  const onDownloadSurveyFile = async (dataDownload: {
    dataType: string
    surveyId: number
    format: string
  }): Promise<void> => {
    try {
      await downloadSurveyFile(dataDownload).unwrap()
    } catch (err) {
      const error = err as FetchBaseQueryError
      showSnackBar(
        (error?.data as { message: string })?.message ?? "An error occurred while downloading a required file",
        "error",
      )
    }
  }

  const onDownloadOriginSurvey = (dataDownload: { surveyId?: number; file?: string }) => {
    downloadOriginSurvey(dataDownload)
  }

  return (
    <SurveyPage
      data={data}
      setData={setData}
      permission={permission}
      surveyData={surveyData}
      surveyById={surveyById}
      commodityBasket={commodityBasket}
      deleteSurvey={onDelete}
      downloadSurveyFile={onDownloadSurveyFile}
      downloadOriginSurvey={onDownloadOriginSurvey}
    />
  )
}

export default SurveyMFI
